import { FC, useEffect, useState } from "react";
import { TaxTypeSelectorModal } from "../../../Business/Dictionaries/TaxType";
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import GridSelectorInput from "../GridSelectorInput";

const TaxTypeSelectorInput: FC<IEntitySelectorInputProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO | undefined>(props.selectedEntity);

    useEffect(() => setEntity({ ...props.selectedEntity }), [props.selectedEntity]);

    return (
        <>
            <GridSelectorInput
                {...props}
                selectorModalJsx={TaxTypeSelectorModal}
                selectedEntity={entity}
                masterIdGlobal={props.masterIdGlobal}
                onSelect={(value) => props.onSelect?.(value)}
                onClear={() => props.onClear?.()}
            />
        </>
    );
};

export default TaxTypeSelectorInput;
